var map = {
	"./favicon.ico": 33,
	"./icons/arrow-down": 4,
	"./icons/arrow-down.svg": 4,
	"./icons/calendar-icon": 5,
	"./icons/calendar-icon.svg": 5,
	"./icons/chevron-left-solid": 6,
	"./icons/chevron-left-solid.svg": 6,
	"./icons/chevron-right-solid": 7,
	"./icons/chevron-right-solid.svg": 7,
	"./icons/customer-management": 8,
	"./icons/customer-management.svg": 8,
	"./icons/dashboard": 9,
	"./icons/dashboard.svg": 9,
	"./icons/download-icon": 10,
	"./icons/download-icon.svg": 10,
	"./icons/house-door-fill": 11,
	"./icons/house-door-fill.svg": 11,
	"./icons/logo": 12,
	"./icons/logo.svg": 12,
	"./icons/person-plus": 13,
	"./icons/person-plus.svg": 13,
	"./icons/plan-icon": 14,
	"./icons/plan-icon.svg": 14,
	"./icons/plus-circle": 15,
	"./icons/plus-circle.svg": 15,
	"./icons/prospect-settings": 16,
	"./icons/prospect-settings.svg": 16,
	"./icons/question-circle-solid": 17,
	"./icons/question-circle-solid.svg": 17,
	"./icons/staff-management": 18,
	"./icons/staff-management.svg": 18,
	"./icons/tilde": 19,
	"./icons/tilde.svg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;